import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dbe7172"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "InvoiceContent" }
const _hoisted_2 = { class: "w-full grid grid-cols-1 gap-6" }
const _hoisted_3 = {
  key: 0,
  class: "InvoiceContent__box"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title" }, "Общая информация", -1))
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "InvoiceContent__row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Клиент", -1))
const _hoisted_9 = { class: "InvoiceContent__row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Тип доставки", -1))
const _hoisted_11 = { class: "InvoiceContent__row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Направление", -1))
const _hoisted_13 = { class: "InvoiceContent__row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Номер накладной заказчика", -1))
const _hoisted_15 = { class: "InvoiceContent__row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Менеджер", -1))
const _hoisted_17 = { class: "InvoiceContent__row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Кто создал", -1))
const _hoisted_19 = { class: "InvoiceContent__row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Дата создания", -1))
const _hoisted_21 = { class: "InvoiceContent__row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Источник заказа", -1))
const _hoisted_23 = {
  key: 0,
  class: "InvoiceContent__row"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Маркетплейс", -1))
const _hoisted_25 = {
  key: 1,
  class: "InvoiceContent__box"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title" }, "ПРЕТЕНЗИИ", -1))
const _hoisted_27 = { class: "mt-3" }
const _hoisted_28 = { class: "w-full" }
const _hoisted_29 = { class: "InvoiceContent__row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Ссылка на претензию", -1))
const _hoisted_31 = { class: "InvoiceContent__row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Тип претензии", -1))
const _hoisted_33 = { class: "InvoiceContent__row" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Описание товара", -1))
const _hoisted_35 = { class: "InvoiceContent__row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Дата создания претензии", -1))
const _hoisted_37 = { class: "InvoiceContent__row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Статус претензии", -1))
const _hoisted_39 = { class: "InvoiceContent__row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "ФИО инициатора", -1))
const _hoisted_41 = {
  key: 2,
  class: "InvoiceContent__box"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title" }, "Оплата", -1))
const _hoisted_43 = { class: "mt-3" }
const _hoisted_44 = { class: "w-full" }
const _hoisted_45 = { class: "InvoiceContent__row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Плательщик", -1))
const _hoisted_47 = { class: "InvoiceContent__row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Способ оплаты", -1))
const _hoisted_49 = { class: "InvoiceContent__row" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Стоимость перевозки", -1))
const _hoisted_51 = { class: "InvoiceContent__row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Наложенный платёж", -1))
const _hoisted_53 = { class: "InvoiceContent__row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Биллинг", -1))
const _hoisted_55 = { class: "flex" }
const _hoisted_56 = { class: "InvoiceContent__row mt-1" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Выставлено", -1))
const _hoisted_58 = { class: "flex" }
const _hoisted_59 = {
  key: 0,
  class: "InvoiceContent__row mt-1"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Ссылка на транскрипт", -1))
const _hoisted_61 = {
  key: 1,
  class: "InvoiceContent__row mt-1"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "InvoiceContent__placeholder" }, [
  /*#__PURE__*/_createElementVNode("p", null, "АВР Спарка Выставление (Номер)"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs font-normal" }, "АВР не является фактом выставления. Для получения точной информации уточните в Бухгалтерии.")
], -1))
const _hoisted_63 = { class: "InvoiceContent__row" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Статус", -1))
const _hoisted_65 = { class: "InvoiceContent__row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Оплачен", -1))
const _hoisted_67 = { class: "InvoiceContent__row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Сумма налички", -1))
const _hoisted_69 = { class: "InvoiceContent__row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Биллинг", -1))
const _hoisted_71 = { class: "flex" }
const _hoisted_72 = {
  key: 3,
  class: "InvoiceContent__box"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title" }, "Отправитель / Забор", -1))
const _hoisted_74 = { class: "mt-3 w-full" }
const _hoisted_75 = { class: "InvoiceContent__row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Наименование", -1))
const _hoisted_77 = { class: "InvoiceContent__row" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Контактное лицо", -1))
const _hoisted_79 = { class: "InvoiceContent__row" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Адрес забора", -1))
const _hoisted_81 = { class: "InvoiceContent__row" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Комментарий", -1))
const _hoisted_83 = { class: "InvoiceContent__row" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Дата забора", -1))
const _hoisted_85 = { class: "InvoiceContent__row" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Самопривоз", -1))
const _hoisted_87 = { class: "InvoiceContent__row" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Сектор", -1))
const _hoisted_89 = { class: "InvoiceContent__row" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Курьер забора", -1))
const _hoisted_91 = {
  key: 5,
  class: "InvoiceContent__box"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title" }, "Получатель / Доставка", -1))
const _hoisted_93 = { class: "mt-3 w-full" }
const _hoisted_94 = { class: "InvoiceContent__row" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Наименование получателя", -1))
const _hoisted_96 = {
  key: 0,
  class: "InvoiceContent__row"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Получатель", -1))
const _hoisted_98 = { class: "InvoiceContent__row" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Контактное лицо", -1))
const _hoisted_100 = { class: "InvoiceContent__row" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Адрес доставки", -1))
const _hoisted_102 = { class: "InvoiceContent__row" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Комментарий", -1))
const _hoisted_104 = { class: "InvoiceContent__row" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Самовывоз", -1))
const _hoisted_106 = { class: "InvoiceContent__row" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Сектор", -1))
const _hoisted_108 = {
  key: 1,
  class: "InvoiceContent__row"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Дата доставки", -1))
const _hoisted_110 = {
  key: 2,
  class: "InvoiceContent__row"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Плановая дата доставки", -1))
const _hoisted_112 = { class: "InvoiceContent__row" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Верификация", -1))
const _hoisted_114 = { class: "InvoiceContent__row" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Кто получил", -1))
const _hoisted_116 = {
  key: 3,
  class: "InvoiceContent__row"
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Курьер доставки", -1))
const _hoisted_118 = {
  key: 7,
  class: "InvoiceContent__box"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title" }, "ОПИСАНИЕ ГРУЗА", -1))
const _hoisted_120 = { class: "InvoiceContent__row" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Длина", -1))
const _hoisted_122 = { class: "InvoiceContent__row" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Ширина", -1))
const _hoisted_124 = { class: "InvoiceContent__row" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Высота", -1))
const _hoisted_126 = { class: "InvoiceContent__row" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Объёмный вес", -1))
const _hoisted_128 = { class: "InvoiceContent__row" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Физический вес", -1))
const _hoisted_130 = { class: "InvoiceContent__row" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Количество мест", -1))
const _hoisted_132 = { class: "InvoiceContent__row" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Наименование товара", -1))
const _hoisted_134 = {
  key: 0,
  class: "InvoiceContent__row"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Страховой полис", -1))
const _hoisted_136 = { class: "InvoiceContent__row" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Коробка", -1))
const _hoisted_138 = { class: "InvoiceContent__row" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Примечание к отправке", -1))
const _hoisted_140 = { class: "InvoiceContent__row" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Температурный режим", -1))
const _hoisted_142 = { class: "InvoiceContent__row" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Опасный груз", -1))
const _hoisted_144 = { class: "InvoiceContent__row" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Наличие батарейки/аккумулятора", -1))
const _hoisted_146 = { class: "InvoiceContent__row" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Наличие автозапчастей", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title mt-2" }, "Страхование груза", -1))
const _hoisted_149 = { class: "mt-3" }
const _hoisted_150 = { class: "w-full" }
const _hoisted_151 = { class: "InvoiceContent__row" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Название", -1))
const _hoisted_153 = { class: "InvoiceContent__row" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Объявленная стоимость", -1))
const _hoisted_155 = {
  key: 1,
  class: "InvoiceContent__row"
}
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Страховой полис", -1))
const _hoisted_157 = {
  key: 8,
  class: "InvoiceContent__box"
}
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title" }, " Обновленная стоимость доставки с учетом корректных замеров ", -1))
const _hoisted_159 = { class: "mt-3 w-full" }
const _hoisted_160 = { class: "InvoiceContent__row" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Объёмный вес", -1))
const _hoisted_162 = { class: "InvoiceContent__row" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Физический вес", -1))
const _hoisted_164 = { class: "InvoiceContent__row" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Количество мест", -1))
const _hoisted_166 = { class: "InvoiceContent__row" }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Стоимость перевозки", -1))
const _hoisted_168 = {
  key: 9,
  class: "InvoiceContent__box"
}
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title" }, "Информация по местам", -1))
const _hoisted_170 = { class: "w-full" }
const _hoisted_171 = { class: "InvoiceContent__row" }
const _hoisted_172 = { class: "InvoiceContent__title" }
const _hoisted_173 = { class: "w-full" }
const _hoisted_174 = { class: "InvoiceContent__row" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Штрих-код места", -1))
const _hoisted_176 = { class: "InvoiceContent__row" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Длина", -1))
const _hoisted_178 = { class: "InvoiceContent__row" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Ширина", -1))
const _hoisted_180 = { class: "InvoiceContent__row" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Высота", -1))
const _hoisted_182 = { class: "InvoiceContent__row" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Объемный вес", -1))
const _hoisted_184 = { class: "InvoiceContent__row" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Физ. вес", -1))
const _hoisted_186 = { class: "InvoiceContent__row" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "На паллете", -1))
const _hoisted_188 = {
  key: 0,
  class: "InvoiceContent__row"
}
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Причина возврата", -1))
const _hoisted_190 = {
  key: 1,
  class: "InvoiceContent__row"
}
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Название продукта", -1))
const _hoisted_192 = {
  key: 2,
  class: "InvoiceContent__row"
}
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Единица", -1))
const _hoisted_194 = {
  key: 3,
  class: "InvoiceContent__row"
}
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Серийный номер", -1))
const _hoisted_196 = {
  key: 4,
  class: "InvoiceContent__row"
}
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Артикул", -1))
const _hoisted_198 = {
  key: 10,
  class: "InvoiceContent__box"
}
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__title mb-3" }, "История статусов", -1))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_201 = {
  key: 11,
  class: "InvoiceContent__box"
}
const _hoisted_202 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, "Загрузка информации...", -1))
const _hoisted_204 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-1 text-gray-500" }, "Нет данных", -1))
const _hoisted_206 = [
  _hoisted_205
]
const _hoisted_207 = { key: 2 }
const _hoisted_208 = { class: "grid grid-cols-4 gap-1" }
const _hoisted_209 = { class: "ml-1" }
const _hoisted_210 = { class: "ml-1" }
const _hoisted_211 = { class: "w-full" }
const _hoisted_212 = { class: "InvoiceContent__row" }
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Название партнера", -1))
const _hoisted_214 = { class: "InvoiceContent__row" }
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Серийный номер", -1))
const _hoisted_216 = { class: "InvoiceContent__row" }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceContent__placeholder" }, "Девайс", -1))
const _hoisted_218 = {
  key: 13,
  class: "InvoiceContent__box"
}
const _hoisted_219 = {
  key: 0,
  class: "border-2 p-2 rounded flex items-center justify-between mb-2"
}
const _hoisted_220 = { class: "flex items-center justify-between" }
const _hoisted_221 = ["href"]
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-white text-xs" }, null, -1))
const _hoisted_223 = {
  key: 1,
  class: "text-sm font-medium text-center text-gray-500"
}
const _hoisted_224 = {
  key: 14,
  class: "InvoiceContent__box grid grid-cols-2 gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_invoice_content_photos = _resolveComponent("invoice-content-photos")!
  const _component_ltl_insurance_table = _resolveComponent("ltl-insurance-table")!
  const _component_handled_value = _resolveComponent("handled-value")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_invoice_history_status_row = _resolveComponent("invoice-history-status-row")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_additional_services_block = _resolveComponent("additional-services-block")!
  const _component_shortcoming_files = _resolveComponent("shortcoming-files")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isGeneral)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.company_name), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.shipment_type), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.direction), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.dop_invoice_number || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.manager
                                        ? _ctx.invoice.manager.email || _ctx.invoice.manager.name
                                        : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.created_by || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("p", null, [
                    (_ctx.invoice.created_at)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.invoice.created_at)), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" - ")
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("p", null, [
                    (_ctx.invoice.source)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.invoice.source), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" - ")
                        ], 64))
                  ])
                ]),
                (_ctx.invoice.marketplaceType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("p", null, _toDisplayString(_ctx.invoice.marketplaceType.short_title || '-'), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPretension && _ctx.isGeneral)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_router_link, {
                    class: "InvoiceContent__link",
                    to: `/pretensions/${_ctx.invoice.pretension.id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`ID: ${_ctx.invoice.pretension.id}`), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.pretension.type_name || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.pretension.product_description || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.pretension.created_at || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.pretension.status_name || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.pretension.client_name || '-'), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPayment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.payment_type) + " ", 1),
                    (_ctx.invoice.payer_company)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" ("),
                          _createVNode(_component_router_link, {
                            class: "text-blue-600 hover:underline",
                            target: "_blank",
                            to: `/companies/${_ctx.invoice.payer_company_id}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.invoice.payer_company), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createTextVNode(") ")
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.payment_method), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("p", null, _toDisplayString(_ctx.getCostPrediction(_ctx.invoice.cost_prediction, _ctx.invoice.status?.code)), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.cod_payment), 1)
                ]),
                (_ctx.invoice.payment_method_id === 3)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("p", _hoisted_55, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["py-1 px-4 text-xs rounded-md flex items-center justify-center text-center font-semibold", { 'bg-blue-600 text-white': _ctx.invoice.billing_enabled, 'bg-gray-100': !_ctx.invoice.billing_enabled }])
                          }, [
                            (_ctx.invoice.billing_enabled)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Включен")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Выключен")
                                ], 64))
                          ], 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("p", _hoisted_58, [
                          (_ctx.invoice.billing_enabled)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["py-1 px-4 text-xs rounded-md flex items-center justify-center text-center font-semibold", { 'bg-green-600 text-white': _ctx.transcriptCreated && !_ctx.transcriptLoading, 'bg-gray-100': !_ctx.transcriptCreated || _ctx.transcriptLoading }])
                              }, [
                                (_ctx.transcriptLoading)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("Загрузка...")
                                    ], 64))
                                  : (_ctx.transcriptCreated)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode("Да")
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode("Нет")
                                      ], 64))
                              ], 2))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["py-1 px-4 text-xs rounded-md flex items-center justify-center text-center font-semibold", { 'bg-green-600 text-white': Boolean(_ctx.invoice.act), 'bg-gray-100': !Boolean(_ctx.invoice.act) }])
                              }, [
                                (Boolean(_ctx.invoice.act))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("Да")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("Нет")
                                    ], 64))
                              ], 2))
                        ])
                      ]),
                      (_ctx.invoice.billing_enabled && _ctx.transcriptCreated)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _hoisted_60,
                            _createElementVNode("p", null, [
                              _createVNode(_component_router_link, {
                                target: "_blank",
                                class: "text-blue-600 hover:underline",
                                to: `/billing/transcripts/${_ctx.transcriptId}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("https://bpms.spark.kz/billing/transcripts/" + _toDisplayString(_ctx.transcriptId), 1)
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ])
                          ]))
                        : (!_ctx.invoice.billing_enabled && _ctx.invoice.act?.actNumber)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                              _hoisted_62,
                              _createElementVNode("p", null, [
                                (Boolean(_ctx.invoice.act))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.invoice.act?.actNumber), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("-")
                                    ], 64))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                    ], 64))
                  : (_ctx.invoice.payment_method_id === 2 || _ctx.invoice.payment_method_id === 4)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("p", null, [
                            (_ctx.cashPaymentLoading)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Загрузка...")
                                ], 64))
                              : (_ctx.cashPaymentFailed)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("Ошибка")
                                  ], 64))
                                : (_ctx.cashPaymentItem)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(_toDisplayString(_ctx.cashPaymentItem.statusName) + " (" + _toDisplayString(_ctx.cashPaymentItem.statusDate) + " ", 1),
                                      (_ctx.cashPaymentItem.user)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.cashPaymentItem.user.name), 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(") ")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode("-")
                                    ], 64))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("p", null, [
                            (Boolean(_ctx.invoice.paid_date_time))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Да")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Нет")
                                ], 64))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("p", null, _toDisplayString(_ctx.invoice.cash_sum ? _ctx.invoice.cash_sum : '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _createElementVNode("p", _hoisted_71, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["py-1 px-4 text-xs rounded-md flex items-center justify-center text-center font-semibold", { 'bg-blue-600 text-white': _ctx.invoice.billing_enabled, 'bg-gray-100': !_ctx.invoice.billing_enabled }])
                            }, [
                              (_ctx.invoice.billing_enabled)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("Включен")
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("Выключен")
                                  ], 64))
                            ], 2)
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSender)
        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _hoisted_76,
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.sender.title), 1)
              ]),
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.sender?.full_name), 1),
                  _createElementVNode("p", null, [
                    (_ctx.invoice.sender.additional_phone)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.invoice.sender.phone) + ", " + _toDisplayString(_ctx.invoice.sender.additional_phone), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.invoice.sender.phone), 1)
                        ], 64))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("p", null, _toDisplayString(_ctx.getSenderAddress), 1)
              ]),
              _createElementVNode("div", _hoisted_81, [
                _hoisted_82,
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.sender.comment || '-------------'), 1)
              ]),
              _createElementVNode("div", _hoisted_83, [
                _hoisted_84,
                _createElementVNode("p", null, _toDisplayString(_ctx.getTakeDate || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.sender.self_delivery ? 'Да' : 'Нет'), 1)
              ]),
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.sender.sectorName ? _ctx.invoice.sender.sectorName : '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_89, [
                _hoisted_90,
                _createElementVNode("p", null, _toDisplayString(_ctx.takeCourier ? _ctx.takeCourier.fullName : '-'), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSender && _ctx.invoice.orderTakePhotos.length > 0)
        ? (_openBlock(), _createBlock(_component_invoice_content_photos, {
            key: 4,
            photos: _ctx.invoice.orderTakePhotos
          }, null, 8, ["photos"]))
        : _createCommentVNode("", true),
      (_ctx.isReceiver)
        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
            _hoisted_92,
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.receiver.title), 1)
              ]),
              (_ctx.isDelivered)
                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                    _hoisted_97,
                    _createElementVNode("p", null, _toDisplayString(_ctx.invoice.delivery_receiver_name || '-'), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_98, [
                _hoisted_99,
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.receiver?.full_name), 1),
                  _createElementVNode("p", null, [
                    (_ctx.invoice.receiver.additional_phone)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.invoice.receiver.phone) + ", " + _toDisplayString(_ctx.invoice.receiver.additional_phone), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.invoice.receiver.phone), 1)
                        ], 64))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _hoisted_101,
                _createElementVNode("p", null, _toDisplayString(_ctx.getReceiverAddress), 1)
              ]),
              _createElementVNode("div", _hoisted_102, [
                _hoisted_103,
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.receiver.comment || '-------------'), 1)
              ]),
              _createElementVNode("div", _hoisted_104, [
                _hoisted_105,
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.receiver.is_pickup ? 'Да' : 'Нет'), 1)
              ]),
              _createElementVNode("div", _hoisted_106, [
                _hoisted_107,
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.receiver.sectorName ? _ctx.invoice.receiver.sectorName : '-'), 1)
              ]),
              (_ctx.invoice.deliveryTimeSlotDate && _ctx.invoice.deliveryTimeSlotTime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                    _hoisted_109,
                    _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.invoice.deliveryTimeSlotDate)) + " (Тайм-слот: " + _toDisplayString(_ctx.formatTimeRange(_ctx.invoice.deliveryTimeSlotTime)) + ")", 1)
                  ]))
                : _createCommentVNode("", true),
              (Boolean(_ctx.clientSlaDate))
                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                    _hoisted_111,
                    _createElementVNode("p", null, _toDisplayString(_ctx.clientSlaDate) + " (резерв +12 часов)", 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_112, [
                _hoisted_113,
                _createElementVNode("p", null, _toDisplayString(_ctx.getVerification), 1)
              ]),
              _createElementVNode("div", _hoisted_114, [
                _hoisted_115,
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.receiverName || '-'), 1)
              ]),
              (_ctx.isCourierName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                    _hoisted_117,
                    _createElementVNode("p", null, _toDisplayString(_ctx.deliveryCourier ? _ctx.deliveryCourier.fullName : '-'), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isReceiver && _ctx.invoice.deliveryPhotos.length > 0)
        ? (_openBlock(), _createBlock(_component_invoice_content_photos, {
            key: 6,
            photos: _ctx.invoice.deliveryPhotos
          }, null, 8, ["photos"]))
        : _createCommentVNode("", true),
      (_ctx.isCargo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
            _hoisted_119,
            _createElementVNode("div", _hoisted_120, [
              _hoisted_121,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.depth || 'Не указан'), 1)
            ]),
            _createElementVNode("div", _hoisted_122, [
              _hoisted_123,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.width || 'Не указан'), 1)
            ]),
            _createElementVNode("div", _hoisted_124, [
              _hoisted_125,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.height), 1)
            ]),
            _createElementVNode("div", _hoisted_126, [
              _hoisted_127,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.volume_weight || 'Не указан'), 1)
            ]),
            _createElementVNode("div", _hoisted_128, [
              _hoisted_129,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.weight || 'Не указан'), 1)
            ]),
            _createElementVNode("div", _hoisted_130, [
              _hoisted_131,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.places), 1)
            ]),
            _createElementVNode("div", _hoisted_132, [
              _hoisted_133,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.product_name || '-'), 1)
            ]),
            (_ctx.invoice.insurance_policy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                  _hoisted_135,
                  _createElementVNode("p", null, "Был отправлен " + _toDisplayString(_ctx.getDate(_ctx.invoice.insurance_policy.createdAt)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_136, [
              _hoisted_137,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.size_type || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_138, [
              _hoisted_139,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.annotation || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_140, [
              _hoisted_141,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.temperature_regime
                                ? _ctx.invoice.temperature_regime.title
                                : 'Не указан'), 1)
            ]),
            _createElementVNode("div", _hoisted_142, [
              _hoisted_143,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.is_dangerous ? 'Да' : 'Нет'), 1)
            ]),
            _createElementVNode("div", _hoisted_144, [
              _hoisted_145,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.has_battery ? 'Да' : 'Нет'), 1)
            ]),
            _createElementVNode("div", _hoisted_146, [
              _hoisted_147,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.has_auto_parts ? 'Да' : 'Нет'), 1)
            ]),
            _hoisted_148,
            _createElementVNode("div", _hoisted_149, [
              _createElementVNode("div", _hoisted_150, [
                _createElementVNode("div", _hoisted_151, [
                  _hoisted_152,
                  _createElementVNode("p", null, _toDisplayString(_ctx.invoice.cargo_name || 'Не указано'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_153, [
              _hoisted_154,
              _createElementVNode("p", null, _toDisplayString(_ctx.invoice.declared_price), 1)
            ]),
            (_ctx.invoice.insurance_policy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                  _hoisted_156,
                  _createElementVNode("p", null, "Был отправлен " + _toDisplayString(_ctx.getDate(_ctx.invoice.insurance_policy.createdAt)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.invoice.insurance_policies && _ctx.invoice.insurance_policies.length)
              ? (_openBlock(), _createBlock(_component_ltl_insurance_table, {
                  key: 2,
                  class: "mt-3",
                  insurancePolicies: _ctx.invoice.insurance_policies
                }, null, 8, ["insurancePolicies"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCargo && _ctx.isParametersHandled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
            _hoisted_158,
            _createElementVNode("div", _hoisted_159, [
              _createElementVNode("div", _hoisted_160, [
                _hoisted_161,
                (_ctx.isParametersHandled)
                  ? (_openBlock(), _createBlock(_component_handled_value, {
                      key: 0,
                      unit: "кг",
                      "old-values": _ctx.invoice.source_characteristics.map((s) => s.volume_weight),
                      "current-value": _ctx.invoice.volume_weight
                    }, null, 8, ["old-values", "current-value"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_162, [
                _hoisted_163,
                (_ctx.isParametersHandled)
                  ? (_openBlock(), _createBlock(_component_handled_value, {
                      key: 0,
                      unit: "кг",
                      "old-values": _ctx.invoice.source_characteristics.map((s) => s.weight),
                      "current-value": _ctx.invoice.weight
                    }, null, 8, ["old-values", "current-value"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_164, [
                _hoisted_165,
                (_ctx.isParametersHandled)
                  ? (_openBlock(), _createBlock(_component_handled_value, {
                      key: 0,
                      unit: "шт",
                      "old-values": _ctx.invoice.source_characteristics.map((s) => s.places),
                      "current-value": _ctx.invoice.places
                    }, null, 8, ["old-values", "current-value"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_166, [
                _hoisted_167,
                (_ctx.isParametersHandled)
                  ? (_openBlock(), _createBlock(_component_handled_value, {
                      key: 0,
                      unit: "₸",
                      "old-values": _ctx.invoice.source_characteristics.map((s) => s.cost_prediction),
                      "current-value": _ctx.invoice.cost_prediction
                    }, null, 8, ["old-values", "current-value"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPlaces && _ctx.isCargo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
            _hoisted_169,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.invoice_places, (place, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `place-${place.id}`,
                class: "mt-3"
              }, [
                _createElementVNode("div", _hoisted_170, [
                  _createElementVNode("div", _hoisted_171, [
                    _createElementVNode("p", _hoisted_172, "Место №" + _toDisplayString(i + 1), 1),
                    (place.status)
                      ? (_openBlock(), _createBlock(_component_cheap, {
                          key: 0,
                          style: { width: 'fit-content' },
                          class: _normalizeClass(_ctx.getCheapClass(place.status.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(place.status.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_173, [
                  _createElementVNode("div", _hoisted_174, [
                    _hoisted_175,
                    _createElementVNode("p", null, _toDisplayString(place.barcode), 1)
                  ]),
                  _createElementVNode("div", _hoisted_176, [
                    _hoisted_177,
                    _createElementVNode("p", null, _toDisplayString(place.depth) + " см", 1)
                  ]),
                  _createElementVNode("div", _hoisted_178, [
                    _hoisted_179,
                    _createElementVNode("p", null, _toDisplayString(place.width) + " см", 1)
                  ]),
                  _createElementVNode("div", _hoisted_180, [
                    _hoisted_181,
                    _createElementVNode("p", null, _toDisplayString(place.height) + " см", 1)
                  ]),
                  _createElementVNode("div", _hoisted_182, [
                    _hoisted_183,
                    _createElementVNode("p", null, _toDisplayString(place.volumeWeight), 1)
                  ]),
                  _createElementVNode("div", _hoisted_184, [
                    _hoisted_185,
                    _createElementVNode("p", null, _toDisplayString(place.weight), 1)
                  ]),
                  _createElementVNode("div", _hoisted_186, [
                    _hoisted_187,
                    _createElementVNode("p", null, _toDisplayString(place.isPallet ? 'Да' : 'Нет'), 1)
                  ]),
                  (place.cancelReason)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                        _hoisted_189,
                        _createElementVNode("p", null, _toDisplayString(place.cancelReason.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (place.productName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                        _hoisted_191,
                        _createElementVNode("p", null, _toDisplayString(place.productName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (place.unitTitle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                        _hoisted_193,
                        _createElementVNode("p", null, _toDisplayString(place.unitTitle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (place.serialNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                        _hoisted_195,
                        _createElementVNode("p", null, _toDisplayString(place.serialNumber), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (place.article)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                        _hoisted_197,
                        _createElementVNode("p", null, _toDisplayString(place.article), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
            _hoisted_199,
            _createVNode(_component_new_table, {
              columns: _ctx.COLUMNS,
              rows: _ctx.statusHistory
            }, {
              td: _withCtx(({ column, row }) => [
                _createVNode(_component_invoice_history_status_row, {
                  column: column,
                  row: row
                }, null, 8, ["column", "row"])
              ]),
              actions: _withCtx(({ row }) => [
                _createVNode(_component_new_button, {
                  class: "NewButton--small NewButton--red",
                  loading: _ctx.state.is_loading,
                  disabled: _ctx.state.is_loading,
                  onClick: ($event: any) => (_ctx.deleteStatus(row.id)),
                  hint: "Удалить"
                }, {
                  default: _withCtx(() => [
                    _hoisted_200
                  ]),
                  _: 2
                }, 1032, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isTransit && _ctx.transit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
            (_ctx.isTripsLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_203
                ]))
              : (!_ctx.transit || !_ctx.transit.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_204, _hoisted_206))
                : (_openBlock(), _createElementBlock("div", _hoisted_207, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transit, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `transit-${i}`,
                        class: "border border-gray-100 mb-3 p-3"
                      }, [
                        _createElementVNode("div", _hoisted_208, [
                          _createVNode(_component_router_link, {
                            class: "text-blue-500",
                            to: `/tms/trips/${item.id}`,
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Рейс "),
                              _createElementVNode("span", _hoisted_209, "№" + _toDisplayString(item.number), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("span", null, _toDisplayString(item.direction), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(item.createdAt)), 1),
                          (item.status)
                            ? (_openBlock(), _createBlock(_component_cheap, {
                                key: 0,
                                style: { width: 'fit-content' },
                                class: _normalizeClass(_ctx.getCheapClass(item.status.id))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.status.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ttns, (ttn, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `ttn-${i}`,
                            class: "grid grid-cols-4 gap-1 mt-2"
                          }, [
                            _createVNode(_component_router_link, {
                              class: "text-blue-500",
                              to: `/tms/ttns/${ttn.id}`,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" ТТН "),
                                _createElementVNode("span", _hoisted_210, "№" + _toDisplayString(ttn.number), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            _createElementVNode("span", null, _toDisplayString(ttn.direction), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(ttn.createdAt)), 1),
                            (ttn.status)
                              ? (_openBlock(), _createBlock(_component_cheap, {
                                  key: 0,
                                  style: { width: 'fit-content' },
                                  class: _normalizeClass(_ctx.getCheapClass(ttn.status.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(ttn.status.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isTradein)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 12 }, _renderList(_ctx.invoice.tradeInInfos, (trd, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "InvoiceContent__box",
              key: `trd-${i}`
            }, [
              _createElementVNode("div", _hoisted_211, [
                _createElementVNode("div", _hoisted_212, [
                  _hoisted_213,
                  _createElementVNode("p", null, _toDisplayString(trd.tradeInPartner.name), 1)
                ]),
                _createElementVNode("div", _hoisted_214, [
                  _hoisted_215,
                  _createElementVNode("p", null, _toDisplayString(trd.serial), 1)
                ]),
                _createElementVNode("div", _hoisted_216, [
                  _hoisted_217,
                  _createElementVNode("p", null, _toDisplayString(trd.device), 1)
                ])
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.isFiles)
        ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
            (_ctx.invoice.msdsFile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                  _createTextVNode(" Паспорт безопасности MSDS "),
                  _createElementVNode("div", _hoisted_220, [
                    _createElementVNode("a", {
                      href: _ctx.invoice.msdsFile.path,
                      target: "_blank",
                      download: ""
                    }, [
                      _createVNode(_component_the_button, {
                        class: "extra-small primary",
                        hint: "Скачать файл"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_222
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_221)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_223, "Нет файлов"))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isAdditional)
        ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
            _createVNode(_component_additional_services_block, {
              title: "Доп. услуги отправителя",
              key: "NewSenderService",
              "is-visible": _ctx.isCanShowSenderServices,
              services: _ctx.invoice.order_additional_services_values
            }, null, 8, ["is-visible", "services"]),
            _createVNode(_component_additional_services_block, {
              title: "Доп. услуги получателя",
              key: "NewReceiverService",
              "is-visible": _ctx.isCanShowReceiverServices,
              services: _ctx.invoice.additional_services_values,
              invoiceNumber: _ctx.invoice.invoice_number
            }, null, 8, ["is-visible", "services", "invoiceNumber"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_shortcoming_files, {
        "order-id": _ctx.invoice.order_id,
        onShortcoming: _ctx.emitShortcoming
      }, null, 8, ["order-id", "onShortcoming"])
    ])
  ]))
}